export class TableDisplayModes {
  static Horizontal = {
    key: 'horizontal',
    description: 'Horizontally (default)',
  };

  static Vertical = {
    key: 'vertical',
    description: 'Vertically',
  };

  static list() {
    return [this.Horizontal, this.Vertical];
  }

  static defaultMode() {
    return this.Horizontal;
  }
}
